// this is an autogenerated file from DesignSystem/ImageComparison/Content/Actions/Choose/ChooseImageAction/Content/Content/Images/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_ImageComparison_Content_Actions_Choose_ChooseImageAction_Content_Content_Images($image_series_id: numeric!) {
  vaxiom_patient_images(
    where: { imageseries_id: { _eq: $image_series_id } }
    order_by: { order: asc }
  ) {
    id
    file_key
    original_file_key
    type_key
    slot_key
  }
}

`